import JSEncrypt from 'jsencrypt/bin/jsencrypt'

const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsnkKStl4PIIUlos9be6E\nY23vXC6tMt24VQAcqzrt5MG9pjEKBK/ZSM0vi9hUFrke5HNM2qa4KqU+8rO05IaV\nOkrDuFmMgYC6YrKlV4fl8SA0bEU/mMLtJKCumMKaQLjDfeU5WvTprYMi2OPHHdFt\nx2UB5wpJIR3iOzK8A9tV2nfWwCaQBTzse1EuXSWeF2zxoTHJwz2Gzd3Dyxjp+BBa\nWA9AXAwKFd/mAow6lrf4lKAnA0CHu3a2ZEA0WDiV71p5t994Ba5pCpdcxiBjYqda\n3RjWgQFvr7GtYsM/S3nmGNPD45rrVWkizIJ6AbN2ZrYqptNA9X/YnB4zU1ySKFY2\nYwIDAQAB';

//公钥加密
export function RSA2_ENCRYPT(passwd) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(passwd)
}
